// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3Gy9A","rightAdornment":"Header_rightAdornment__EK-WQ"};